import { emitterCreateDispatcher } from '@THC/utils/emitter';

import { ErrorInfoboxEmitter } from './ErrorInfoboxEmitter';

const dispatchEvent = emitterCreateDispatcher(ErrorInfoboxEmitter);

export const errorInfoboxSetError = dispatchEvent('set');
